import _ from 'lodash'
import MapUtil from '@/utils/mapUtil'

const state = {
  routes: [], // 路由点的数组
  resetWayPointFlag: false,
  routeLayerVisible: false, // 标示是否显示路由点
  excWayPointArr: _.cloneDeep(MapUtil.EXC_WAYPOINT_DEFAULT_ARR),
  copyExcWayPointArr: [],
  preservedExcWayPointArr: [],

  requiredWayPointArr: [],
  wayPointConfig: _.cloneDeep(MapUtil.WAYPOINT_CONFIG)
}

const mutations = {
  setRouteLayerVisible (state, payload) { // 改变路由点的显示状态
    state.routeLayerVisible = payload
  },

  setResetWayPointFlag (state, payload) {
    state.resetWayPointFlag = payload
  },

  setRoutes (state, payload) { // 设置路由点数据
    state.routes = payload
  },

  setWayPointConfig (state, payload) {
    state.wayPointConfig = payload
  },

  resetWayPointArr (state, payload) { // copyExcWayPointArr
    state.excWayPointArr = _.cloneDeep(MapUtil.EXC_WAYPOINT_DEFAULT_ARR)
    state.copyExcWayPointArr = []
    state.preservedExcWayPointArr = []
    state.requiredWayPointArr = []

    state.wayPointConfig = _.cloneDeep(MapUtil.WAYPOINT_CONFIG)
  },

  updateExcWayPointArr (state, payload) {
    var index = state.excWayPointArr.indexOf(payload.waypointID)
    if (index !== -1) {
      if (payload.option !== MapUtil.WAYPOINT_TYPE_EXC) { state.excWayPointArr.splice(index, 1) }
    } else {
      // 数组中没有，但禁止通过的添加进数组
      if (payload.option == MapUtil.WAYPOINT_TYPE_EXC) { state.excWayPointArr.push(payload.waypointID) }
    }

    var copyIndex = state.copyExcWayPointArr.indexOf(payload.waypointID)
    if (copyIndex !== -1) {
      if (payload.option !== MapUtil.WAYPOINT_TYPE_EXC) { state.copyExcWayPointArr.splice(copyIndex, 1) }
    } else {
      // 数组中没有，但禁止通过的添加进数组
      if (payload.option == MapUtil.WAYPOINT_TYPE_EXC) { state.copyExcWayPointArr.push(payload.waypointID) }
    }
  },

  setPreservedExcWayPointArr (state, payload) {
    state.preservedExcWayPointArr = payload
  },

  addRequiredWayPoint (state, payload) {
    var index = state.requiredWayPointArr
      .findIndex(ele => ele.PortID === payload.PortID)
    if (index == -1) {
      state.requiredWayPointArr.push(payload)
    }
  },
  removeRequiredWayPoint (state, payload) {
    var index = state.requiredWayPointArr
      .findIndex(ele => ele.PortID === payload.PortID)
    if (index !== -1) {
      state.requiredWayPointArr.splice(index, 1)
    }
  }

}

const actions = {}

export default {
  state,
  actions,
  mutations
}
